export default "__VITE_ASSET__BGoo1v2n__"